import React, { useEffect } from "react";
import { styled } from "styled-components";
import { Colors } from "../../ColorConstants";

const NoteCard = ({ data }) => {
  return (
    <NoteContainer>
      {data?.disclaimer && (
        <>
          <NoteDescription>NOTE:</NoteDescription>
          <NoteDescription>* {data?.disclaimer}</NoteDescription>
        </>
      )}
      {data?.tc && (
        <>
          <NoteDescription>TERMS & CONDITIONS</NoteDescription>
          <NoteDescription>* {data?.tc}</NoteDescription>
        </>
      )}
    </NoteContainer>
  );
};

const NoteContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const NoteDescription = styled.div`
  font-size: 1rem;
  color: ${Colors.grey};
`;

export default NoteCard;
